import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import PUBLIC_ROUTES from '_helpers/constants/ConstPublicRoutes';
import AnimatedPage from 'layout/AnimatedPage';
import { AnimatePresence } from 'framer-motion';
import NavigationArrows from 'layout/NavigationArrows';

export default function PublicRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes key={location.pathname} location={location}>
        {PUBLIC_ROUTES.map(e => (
          <Route
            key={e.path}
            path={e.path}
            element={
              <div className="h-full w-full relative">
                <NavigationArrows />
                <AnimatedPage>
                  <e.component />
                </AnimatedPage>
              </div>
            }
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
}
